var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("mandate.sdd_blacklist.title") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "div",
                { staticClass: "requestsList" },
                [
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex justify-content-start",
                          attrs: { cols: "6" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2",
                              on: { click: _vm.onRefresh },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-light fa-rotate-right",
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.rfrsh")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex justify-content-end",
                          attrs: { cols: "6" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2",
                              on: { click: _vm.openCreatePopup },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-plus" }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "mandate.sdd_blacklist.generation_button"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-auto" }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("h5", { staticClass: "mb-3" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "mandate.sdd_blacklist.existing_blacklist"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mx-auto mb-4", attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            [
                              _vm.activateSpinner
                                ? _c("spinner")
                                : _vm.tableItems.length > 0
                                ? _c("b-table", {
                                    key: _vm.refreshKey,
                                    staticClass: "table table-striped",
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: {
                                      hover: "",
                                      striped: "",
                                      responsive: "",
                                      "no-local-sorting": "",
                                      items: _vm.paginatedTableItems,
                                      fields: _vm.fields,
                                      "sort-by": _vm.sortBy,
                                      "sort-desc": _vm.sortDesc,
                                      "empty-text": _vm.$t("common.no_result"),
                                    },
                                    on: {
                                      "update:sortBy": function ($event) {
                                        _vm.sortBy = $event
                                      },
                                      "update:sort-by": function ($event) {
                                        _vm.sortBy = $event
                                      },
                                      "update:sortDesc": function ($event) {
                                        _vm.sortDesc = $event
                                      },
                                      "update:sort-desc": function ($event) {
                                        _vm.sortDesc = $event
                                      },
                                      "sort-changed": _vm.onSortChanged,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "cell(actions)",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center align-items-center",
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "action-icon p-1 mr-2",
                                                    class: {
                                                      "action-icon-disabled":
                                                        String(
                                                          item.editable
                                                        ) !== "1",
                                                    },
                                                    attrs: {
                                                      variant: "link",
                                                      disabled:
                                                        String(
                                                          item.editable
                                                        ) !== "1",
                                                      title: _vm.$t(
                                                        "mandate.sdd_blacklist.edit"
                                                      ),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.openEditPopup(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-pencil",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "action-icon action-icon-delete p-1",
                                                    class: {
                                                      "action-icon-disabled":
                                                        String(
                                                          item.editable
                                                        ) !== "1",
                                                    },
                                                    attrs: {
                                                      variant: "link",
                                                      disabled:
                                                        String(
                                                          item.editable
                                                        ) !== "1",
                                                      title: _vm.$t(
                                                        "mandate.sdd_blacklist.delete"
                                                      ),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.deleteBlacklist(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-xmark",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.activateSpinner
                                ? _c(
                                    "b-row",
                                    { staticClass: "mt-1" },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("cm-pagination", {
                                            attrs: {
                                              maxResultsByPage:
                                                _vm.paginationObject.maxResults,
                                              firstIndex:
                                                _vm.paginationObject.firstIndex,
                                              nbResultsTotal:
                                                _vm.paginationObject
                                                  .nbResultsTotal,
                                              refreshEvent:
                                                _vm.paginationObject.refresh,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center",
                                    },
                                    [
                                      _c("span", { staticClass: "noResult" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("common.no_result")) +
                                            "\n                "
                                        ),
                                      ]),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showBlacklistPopup
                ? _c("blacklist-pop-up", {
                    attrs: {
                      form: _vm.popupForm,
                      type: _vm.popupType,
                      "is-edit": _vm.isEditMode,
                    },
                    on: { close: _vm.closePopup, savepopup: _vm.savePopup },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }